import { type IconName, MenuItem, MenuItemProps } from '@beeline.com/bp-design-system';
import AppLink from 'common/AppLink/AppLink';
import { LocationDescriptorObject } from 'history';
import React, { AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';
import { Pathname } from 'utils/hooks/navigation/types';

interface HeaderActionProps {
  to?: Pathname | LocationDescriptorObject<unknown>;
  rel?: string;
  onClick?: (event: EventFor<'li', 'onClick'> | React.MouseEvent<HTMLElement>) => void;
  icon?: React.ReactNode | IconName;
  text: React.ReactNode;
  dataTest: string;
}

export const HeaderAction = React.forwardRef(
  (
    {
      to,
      onClick,
      icon,
      dataTest,
      text,
      ...aProps
    }: HeaderActionProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'>,
    ref: React.Ref<HTMLAnchorElement>
  ) => {
    const appLinkProps = !!to ? { to, hideTextDecoration: true } : {};

    return (
      <StyledMenuItem
        ref={ref}
        dataTest={dataTest}
        onClick={onClick}
        component={!!to ? AppLink : !!aProps?.href ? 'a' : undefined}
        {...appLinkProps}
        {...aProps}
        endIcon={icon}
        slotProps={{
          endIcon: {
            size: 18
          }
        }}
      >
        {text}
      </StyledMenuItem>
    );
  }
);

const StyledMenuItem: (props: MenuItemProps<'a' | 'li' | typeof AppLink>) => JSX.Element = styled(MenuItem)`
  && {
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-width: 150px;
    &:focus {
      box-shadow: none;
    }
  }
`;
